import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import { ActionSection, ModalHeader, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";
import { dueTypes } from "../../Config";
import { useSelector } from "react-redux";

const FilterModal = ({
    selectedData,
    onApplyFilter,
    handleClose,
    currentFilter,
    handleClearFilters,
    canHideDues,
}) => {
    const [activeType, setActiveType] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [height, setHeight] = useState(window.innerHeight);
    const locations = useSelector((state) => state.LocationsReducer.locations);
    const filteredLocations = locations.filter(location => location.id !== 0);
    const getFilterGroups = () => {
        const groups = [
            {
                key: "sortBy",
                title: "Sort By",
                prefix: "SORT_",
                options: [
                    { label: "Max Due Amount", value: "MA" },
                    { label: "Min Due Amount", value: "MI" },
                    { label: "Oldest First", value: "DDMI" },
                    { label: "Recent First", value: "DDMA" },
                ],
            },
            {
                key: "pendingDuration",
                title: "Pending Duration",
                prefix: "PEND_",
                options: [
                    { label: "5+ days pending", value: "5OD" },
                    { label: "10+ days pending", value: "10OD" },
                    { label: "15+ days pending", value: "20OD" },
                    { label: "30+ days pending", value: "30OD" },
                ],
            },
            {
                key: "dueType",
                title: "Due Type",
                prefix: "DUE_",
                options: dueTypes.map(item => ({
                    label: item.label,
                    value: String(item.value),
                })),
            },
            {
                key: "locations",
                title: "Locations",
                prefix: "LOC_",
                options: filteredLocations.map(item => ({
                    label: item.name,
                    value: String(item.id),
                })),
            },
        ];

        if (canHideDues === 1) {
            groups.push({
                key: "hiddenDues",
                title: "Hidden Dues",
                prefix: "HIDE_",
                options: [{ label: "Show", value: "HD" }],
            });
        }

        return groups;
    };
    const filterGroups = getFilterGroups();

    /* ------------------ preselect on open ------------------ */
    // useEffect(() => {
    //     if (!currentFilter) return;

    //     for (const group of filterGroups) {
    //         const match = group.options.find(o => o.value === currentFilter);
    //         if (match) {
    //             setActiveType(group.key);
    //             setSelectedFilter({
    //                 type: group.title,
    //                 value: match.value,
    //                 label: match.label,
    //             });
    //             break;
    //         }
    //     }
    // }, [currentFilter]);
    /* ------------------ preselect on open ------------------ */
    useEffect(() => {
        if (!currentFilter) {
            // Default to sortBy
            setActiveType("sortBy");
            const defaultOption = filterGroups.find(g => g.key === "sortBy")?.options[0];
            if (defaultOption) {
                setSelectedFilter({
                    type: "Sort By",
                    value: defaultOption.value,
                    label: defaultOption.label,
                });
            }
            return;
        }

        // Parse the current filter value to determine type
        for (const group of filterGroups) {
            if (currentFilter.startsWith(group.prefix)) {
                const rawValue = currentFilter.replace(group.prefix, "");
                const match = group.options.find(o => o.value === rawValue);

                if (match) {
                    setActiveType(group.key);
                    setSelectedFilter({
                        type: group.title,
                        value: match.value,
                        label: match.label,
                    });
                    break;
                }
            }
        }
    }, [currentFilter]);

    useEffect(() => {
        const resize = () => setHeight(window.innerHeight);
        window.addEventListener("resize", resize);
        return () => window.removeEventListener("resize", resize);
    }, []);

    const handleApply = () => {
        if (!selectedFilter) {
            toast.error("Please select at least one filter before applying.");
            return;
        }
        onApplyFilter(
            selectedFilter.value,
            selectedFilter.label,
            selectedFilter.type
        );
    };

    const activeGroup =
        filterGroups.find(g => g.key === activeType) || filterGroups[0];

    return (
        <Container style={{ height }}>
            {/* Header */}
            <ModalHeader>
                <h1 className="text-lg font-medium text-white">Filters</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            {/* Body */}
            <Body>
                {/* LEFT – Filter Types */}
                <LeftPane>
                    {filterGroups.map(group => {
                        const active = activeType === group.key;
                        return (
                            <TypeItem
                                key={group.key}
                                active={active}
                                onClick={() => setActiveType(group.key)}
                            >
                                {group.title}
                            </TypeItem>
                        );
                    })}
                </LeftPane>

                {/* RIGHT – Options */}
                <RightPane>
                    <FilterTitle>
                        {activeGroup.title}
                    </FilterTitle>

                    {activeGroup.options.map(option => {
                        const isCurrentType = selectedFilter?.type === activeGroup.title;
                        const checked = isCurrentType &&
                            selectedFilter?.value === option.value;
                        // const checked = selectedFilter?.value === option.value;

                        return (
                            <OptionRow
                                key={option.value}
                                onClick={() =>
                                    setSelectedFilter({
                                        type: activeGroup.title,
                                        value: option.value,
                                        label: option.label,
                                    })
                                }
                            >
                                <input
                                    type="radio"
                                    checked={checked}
                                    readOnly
                                    style={{ margin: 0, width: 16 }}
                                />
                                <span className="leading-tight text-sm text-gray-600">{option.label}</span>
                            </OptionRow>
                        );
                    })}

                </RightPane>
            </Body>

            {/* Footer */}
            {/* <Footer>
                <ClearBtn onClick={handleClearFilters}>Clear</ClearBtn>
                <ApplyBtn onClick={handleApply}>Apply Filter</ApplyBtn>
            </Footer> */}
            <ActionSection>
                <SideCancelBtn type="button" onClick={handleClearFilters}>
                    Clear
                </SideCancelBtn>
                <SubmitBtn type="submit" onClick={handleApply}>
                    Apply Filter
                </SubmitBtn>
            </ActionSection>

        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color px-4 py-4`;

const Body = tw.div`flex flex-1 overflow-hidden`;

const LeftPane = tw.div`
  w-1/3 bg-gray-50 border-r overflow-y-auto`;

const TypeItem = tw.div`
  px-4 py-4 cursor-pointer text-md
  ${({ active }) =>
        active
            ? "bg-blue-50 text-primary-color font-medium border-l-4 border-primary-color"
            : "text-gray-700 hover:bg-gray-100"}
`;
// text-md font-medium text-gray-800 mb-2
// const RightPane = tw.div`
//   flex-1 px-6 py-4 overflow-y-auto mr-auto bg-red-100
// `;

// const OptionRow = tw.div`
//   flex gap-3 py-3 cursor-pointer text-sm text-gray-800
//   hover:bg-gray-50 rounded-md px-2
// `;

const RightPane = tw.div`
  flex-1
  py-4
  pl-4
  pr-6
  overflow-y-auto
`;


const OptionRow = tw.div`
  flex items-center gap-3
  py-3 px-2
  cursor-pointer
  text-sm text-gray-400
  rounded-md
  hover:bg-gray-50
`;

const FilterTitle = tw.h3`text-md font-medium text-gray-700 mb-2`;


export default FilterModal;
